import { Observable } from 'rxjs';
import {
    CartStep1Interface,
    CartStep1ResponseInterface,
} from '../models/cart-step1.model';

export abstract class CartStep1Repository {
    abstract sendCartStep1(
        array: CartStep1Interface,
    ): Observable<CartStep1ResponseInterface>;
}
